import axios from 'axios'
// import qs from 'qs' // 序列化请求数据，视服务端的要求
// create an axios instance
axios.defaults.headers.post['Content-Type'] = 'application/json'
const service = axios.create({
  method: 'post',
  baseURL: 'http://datacenter.civaonline.cn/dataCenter-service', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // config.data = qs.stringify(config.data)
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    return res
  },
  error => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)

export default service
